import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CourseNav from '../../../components/CourseNav';
import Library from './Library';
import Details from './Details';
// import Error404 from '../Error404';
import LibraryTypeSwitch from '../../../components/LibraryTypeSwitch';

class Courses extends Component {
  constructor (props) {
    super(props);
    this.typeClickHandler = this.typeClickHandler.bind(this);
    this.state = {
      courseType: 'tutored'
    };
  }

  typeClickHandler (courseType) {
    this.setState(
      {
        courseType: courseType
      }
    );
  }

  render () {
    const self = this;
    return (
      <div className='l-container'>
        <Helmet>
          <title>Learn British Sign Language Online with BSL Courses</title>
        </Helmet>
        <CourseNav />
        <LibraryTypeSwitch courseType={this.state.courseType} handleTypeClick={this.typeClickHandler} />
        <switch>
          <Route exact path='/courses' render={({match}) => {
            if (self.props.courses.length > 0) {
              return <Library courses={self.props.courses} courseType={this.state.courseType} />;
            } else {
              return <div>Loading...</div>;
            }
          }
          } />
          <Route path='/courses/*' render={({match}) => {
            if (self.props.courses.length > 0) {
              return <Details courses={self.props.courses} courseType={this.state.courseType} />;
            } else {
              return <div>Loading...</div>;
            }
          }
          } />
        </switch>
      </div>
    );
  }
}

Courses.propTypes = {
  courses: PropTypes.array
};

export default Courses;



// WEBPACK FOOTER //
// ./src/views/Main/Courses/index.js